import React from 'react';
import { Link } from 'react-router-dom';

const Support = () => (
  <div className="card">
    <div className="card-body">
      <h3 className="h5 fw-bold mb-2">Support</h3>
      <p className="text-muted mb-3">
        Internal support tools for managing communications and account recovery.
      </p>
      <Link className="btn btn-outline-primary btn-sm" to="/account/support/email-templates">
        Email Templates
      </Link>
    </div>
  </div>
);

export default Support;
